module.exports = __webpack_public_path__ + "img/40.aa4bfcc6.png";